import api from '../../api/index.js'

const state = {
    VDistributionLevel:null
}

const getters = {

}

const actions = {
    DistributionLevelSearch({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/DistributionLevel/DistributionLevelSearch',payload, res => {
                resolve(res.Result)
                commit(
                {
                    type: "setVDistributionLevel",
                    res: res.Result,
                });
            }, err => {
                reject(err)
            }) 
        });
    },
    GetDistributionLevelById({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/DistributionLevel/GetDistributionLevelById',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    DistributionLevelTransactionrAdd({commit},payload)
    {
        return new Promise((resolve,reject) => {
            api.post('/DistributionLevel/DistributionLevelTransactionrAddVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    }
    
}

const mutations = {
    setVDistributionLevel(state, payload){
        state.VDistributionLevel=payload.res;

    }

}

export default {
    state,
    getters,
    actions,
    mutations
}
